import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BlockScopingContextProvider } from "@geome/react-next/lib/context/blockScoping";
import { useBEM } from "@geome/react-next/lib/hooks/useBEM";
import { LinksList } from "../linksList";
export const Breadcrumbs = ({ breadcrumbs = [], renderAfter, seperatorStyle, }) => {
    const breadcrumbsClassName = useBEM({
        block: "breadcrumbs",
        modifiers: {
            "seperator-chevrons": seperatorStyle === "chevrons",
            "seperator-slashes": seperatorStyle === "slashes",
            "seperator-dots": seperatorStyle === "dots",
        },
    });
    const breadcrumbsLinkClassName = useBEM({
        block: "breadcrumbs",
        element: "link",
        modifiers: {
            "seperator-chevrons": seperatorStyle === "chevrons",
            "seperator-slashes": seperatorStyle === "slashes",
            "seperator-dots": seperatorStyle === "dots",
        },
    });
    return (_jsx(BlockScopingContextProvider, { block: "breadcrumbs", children: _jsxs("div", { className: breadcrumbsClassName, children: [_jsx("div", { className: "breadcrumbs__links", children: _jsx(LinksList, { className: breadcrumbsLinkClassName, links: breadcrumbs }) }), renderAfter && _jsx("div", { className: "breadcrumbs__after", children: renderAfter() })] }) }));
};
